import React from 'react';
import homeimg from './smartphone.png';


const homeimage = () =>{
    return(
        <img className="home-image"src={homeimg} alt="Mobile"></img>
    )
}

export default homeimage;